import { fork, takeLatest, all } from 'redux-saga/effects'
import {
  MAP_OBJECTS_ERRORS,
  REFRESH_WIDGET_MAP,
  CHANGE_OBJECT_STATE
} from '@/store/actions/maps'

import refreshEquipment from './refreshEquipment'
import monitoringErrors from './monitoringErrors'
import changeObjectState from './changeObjectState'

function* watchStateRequest() {
  yield takeLatest(MAP_OBJECTS_ERRORS.EVENTS, monitoringErrors)
  yield takeLatest(REFRESH_WIDGET_MAP.EVENTS, refreshEquipment)
  yield takeLatest(CHANGE_OBJECT_STATE.EVENTS, changeObjectState)
  // yield takeLatest(MAP_OBJECTS_NOTIFICATIONS.EVENTS, monitoringNotifications)
}

const stateSaga = [fork(watchStateRequest)]

export default function* rootSaga() {
  yield all([...stateSaga])
}
